import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { flagsmith } from '@common/Lib/Flagsmith';
import { buildProductTitle } from '@common/Utility/common-utils';
import { CheckboxControl } from '@common/Component/Forms';
import { PLUS_ICON, PRODUCT_CARD_DEFAULT } from '../../../../public/images';
import { getImageUrlWithSize } from '@common/Utility/common-utils';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const FBTProduct = ({ id, isFirstElement, link, image, title, price, previousPrice, handleCheckedItems, productInCart, cartData, parentSku, notInCart, newDataSet, disable}) => {
  const generateURL = useNavigationURL();

  const fbtAddToCartData = useSelector((state) => state?.epharmacy?.FBTAddToCart?.data?.data);
  const reducerItems = useSelector((state) => state?.app?.pdpReducer?.items);
  const [failedToCart, setFailedToCart] = useState(false);
  const [checked, setChecked] = useState(true);
  const [inCart, setInCart] = useState(false);
  const [src, setSrc] = useState(image);
  const [innerWidth, setInnerWidth] = useState(0);
  const ae_web_cartfillersConfig = flagsmith.getValue('ae_web_cartfillers', { json: true });
  const showEllipsisInTitle = ae_web_cartfillersConfig?.showEllipsisInTitle;

  useEffect(() => {
    if (isFirstElement && disable) {
      setChecked(false);
      handleCheckedItems(parentSku, false);
    }
  }, [disable, fbtAddToCartData?.failedToAdd]);

  React.useEffect(()=>{
    fbtAddToCartData?.failedToAdd.map((item_id) => {
      if(item_id === id) {
        setFailedToCart(true);
        setChecked(false);
        handleCheckedItems(id, false);
      }
      return item_id;
    });

  },[fbtAddToCartData]);

  useEffect(() => {
    if(typeof window !== 'undefined') {
      setInnerWidth(window.innerWidth);
    }
  }, [window.innerWidth]);

  React.useEffect(() => {
    if(fbtAddToCartData?.failedToAdd.length > 0){
      if(!fbtAddToCartData?.failedToAdd.includes(id) && !failedToCart){
        setChecked(true);
        handleCheckedItems(id, true);
      }
      if(parentSku && isFirstElement && disable){
        setChecked(false);
        handleCheckedItems(parentSku, false);
      }
    }else if(fbtAddToCartData?.failedToAdd.length === 0 && !failedToCart){
        setChecked(true);
        handleCheckedItems(id, true);
    }
  },[fbtAddToCartData]);

  const handleChange = (pid, checkState) => {
    setChecked(checkState);
    handleCheckedItems(pid, checkState);
  };

  useEffect(() => {
    const isInCart = reducerItems?.some(item => item?.item_id === parentSku);
    setInCart(isInCart);
  },[cartData]);

  useEffect(() =>{
    if(productInCart !== '' || notInCart.length > 0){
      let cart = true;
       if(inCart && productInCart !== '' && id === parentSku){
        cart = false;
      }else if(notInCart.length > 0 && id === parentSku){
        cart = true;
      }
      if(id === parentSku){
        setChecked(cart);
        handleCheckedItems(parentSku, cart);
      }
    }
  }, [productInCart, notInCart, inCart]);

  const renderTitle = (content) => {
    let charPerRow = 13;
    if (window.innerWidth <= 375) {
      charPerRow = 7;
    } else if (window.innerWidth <= 430) {
      charPerRow = 9;
    }
    return buildProductTitle({ content, showEllipsisInTitle, charPerRow });
  };

  return (
    <>
      {!isFirstElement && <div className="fbt-product-separator">
      <div className="plus-icon"> 
      <Image 
      src={PLUS_ICON} 
      alt="PLUS_ICON" 
      width={60}
      height={60}
       />
       </div> 
        </div>}
      <div className={failedToCart? "fbt-product failedToAdd": "fbt-product"}>
        
        <a href={generateURL(link)} rel="noopener noreferrer">
        <div className="fbt_checkbox">
        {isFirstElement ? (
              <CheckboxControl
              appVariant="epharmacy"
              checked={checked}
              disable={disable}
              onChange={(e) => handleChange(id, e.target.checked)}
            />
            ) : (
              <CheckboxControl
                appVariant="epharmacy"
                checked={checked}
                onChange={(e) => handleChange(id, e.target.checked)}
              />
            )}
        </div>
        <Image onError={()=>setSrc(PRODUCT_CARD_DEFAULT.src)} src={getImageUrlWithSize(src, 100, 100) || PRODUCT_CARD_DEFAULT.src} alt="product img" className="fbt_img" width={100} height={100} unoptimized/>
        <p>{renderTitle(title)}</p> 
        <div className="price-label">
          <span>{price}</span>
          {(previousPrice !== null) && <del>{previousPrice}</del>}
        </div>
        </a>
      </div>
    </>
  );
};

FBTProduct.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  previousPrice: PropTypes.string,
  image: PropTypes.string,
  isFirstElement: PropTypes.bool,
  handleCheckedItems: PropTypes.func,
  link: PropTypes.string,
  productInCart: PropTypes.string,
  cartData: PropTypes.array,
  parentSku: PropTypes.string,
  notInCart: PropTypes.array,
  disable: PropTypes.bool,
  
};

FBTProduct.defaultProps = {
  previousPrice: '',
  image: '',
  isFirstElement: true,
  handleCheckedItems: () => {},
  link: '',
  productInCart: '',
  cartData: [],
  parentSku: '',
  notInCart: [],
  disable: false,
};

export default FBTProduct;
